
import { useEffect } from 'react';
import { getRecaptchaScriptUrl } from '@/utils/configService';

export function useRecaptcha() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = getRecaptchaScriptUrl();
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    
    return () => {
      // Remove script only if we added it
      const scriptElement = document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]');
      if (scriptElement && scriptElement.parentNode) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
    };
  }, []);
}
